import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import MindsetsJsSDK, {
    ErrorMessageAction,
    SuccessMessageAction,
    authUtils,
    accessConstants,
    LoadCurriculaAction,
    Checkbox
} from "mindsets-js-sdk";
import NoAccess from "../../common/NoAccess";
import {CHALLENGE_RESOURCE_TITLES} from "../ChallengeResources";

export default function () {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const me = useSelector(state => state.me);
    const curricula_all = useSelector(state => state.curricula);
    const [challenge_code, setChallengeCode] = useState('');
    const [title, setTitle] = useState('');
    const [url, setUrl] = useState('');
    const [name, setName] = useState(null);
    const [description, setDescription] = useState(null);
    const [quiz, setQuiz] = useState(null);
    const [links, setLinks] = useState(null);
    const [curricula, setCurricula] = useState(null);

    useEffect(() => {
        dispatch(LoadCurriculaAction());
        MindsetsJsSDK().API
            .get(`challenge_resources/${params.challenge_resource_id}`)
            .then(response => {
                setChallengeCode(response.challenge_resource.challenge_code);
                setTitle(response.challenge_resource.title);
                setName(response.challenge_resource.name);
                setUrl(response.challenge_resource.url);
                setDescription(response.challenge_resource.description);
                setQuiz(response.challenge_resource.quiz);
                setLinks(response.challenge_resource.links);
                setCurricula(response.challenge_resource.curricula);
            })
            .catch(error => {
                dispatch(ErrorMessageAction(error));
                console.error(error);
            });

        return () => {
            setChallengeCode('');
            setTitle('');
            setUrl('');
            setName(null);
            setDescription(null);
            setQuiz(null);
            setLinks(null);
            setCurricula(null);
        };
    }, []);

    function getEmptyLink() {
        return {
            title: '',
            url: '',
            language: ''
        }
    }

    function renderLinks() {
        if (Array.isArray(links) && links.length > 0) {
            return links.map((link, index) => {
                return (
                    <div key={index} className='bordered position-relative'>
                        <i
                            className='fas fa-trash red clickable position-absolute'
                            style={{top: '4px', right: '4px'}}
                            onClick={() => {
                                const links_new = JSON.parse(JSON.stringify(links));
                                links_new.splice(index, 1);
                                if (links_new.length > 0) {
                                    setLinks(links_new);
                                } else {
                                    setLinks(null);
                                }
                            }}
                        />
                        <div>
                            <label>Title</label>
                            <input
                                className='full'
                                type="text"
                                value={link.title}
                                onChange={event => {
                                    const links_new = JSON.parse(JSON.stringify(links));
                                    links_new[index].title = event.target.value;
                                    setLinks(links_new);
                                }}
                            />
                        </div>
                        <div>
                            <label>URL</label>
                            <input
                                className='full'
                                type="text"
                                value={link.url}
                                onChange={event => {
                                    const links_new = JSON.parse(JSON.stringify(links));
                                    links_new[index].url = event.target.value;
                                    setLinks(links_new);
                                }}
                            />
                        </div>
                        <div>
                            <label>Language</label>
                            <input
                                className='full'
                                type="text"
                                value={link.language}
                                onChange={event => {
                                    const links_new = JSON.parse(JSON.stringify(links));
                                    links_new[index].language = event.target.value;
                                    setLinks(links_new);
                                }}
                            />
                        </div>
                    </div>
                );
            });
        }

        return 'No links'
    }

    if (authUtils.iCant(me, [accessConstants.PERMISSION_CAN_MANAGE_CHALLENGES])) {
        return (
            <NoAccess/>
        );
    }

    if (!challenge_code) {
        return null;
    }

    return (
        <div className='container'>
            <h1>Update Resource</h1>

            <div className='section d-flex flex-column flex-gap-10'>
                <div>
                    <label>Challenge Code*</label>
                    <input
                        className='full'
                        type="text"
                        value={challenge_code}
                        onChange={event => setChallengeCode(event.target.value)}
                    />
                </div>
                <div>
                    <label>Title*</label>
                    <select
                        className='full'
                        value={title ? title : ''}
                        onChange={event => setTitle(event.target.value)}>
                        <option value='' disabled={true}>Please select</option>
                        {CHALLENGE_RESOURCE_TITLES.map(title => {
                            return (
                                <option value={title} key={title}>{title}</option>
                            );
                        })}
                    </select>
                </div>
                <div>
                    <label>Name</label>
                    <input
                        className='full'
                        type="text"
                        value={name ? name : ''}
                        onChange={event => {
                            const value = event.target.value;
                            if (value) {
                                setName(value);
                            } else {
                                setName(null);
                            }
                        }}
                    />
                </div>
                <div>
                    <label>URL</label>
                    <input
                        className='full'
                        type="text"
                        value={url}
                        onChange={event => setUrl(event.target.value)}
                    />
                </div>
                <div>
                    <label>Description</label>
                    <textarea
                        className='full'
                        value={description ? description : ''}
                        onChange={event => {
                            const value = event.target.value;
                            if (value) {
                                setDescription(value);
                            } else {
                                setDescription(null);
                            }
                        }}
                    />
                </div>
                <div>
                    <label>Quiz</label>
                    <input
                        className='full'
                        type="text"
                        value={quiz ? quiz : ''}
                        onChange={event => {
                            const value = event.target.value;
                            if (value) {
                                setQuiz(value);
                            } else {
                                setQuiz(null);
                            }
                        }}
                    />
                </div>
                <div>
                    <label>Curricula</label>
                    <div className='d-flex flex-gap-5 flex-wrap'>
                        {curricula_all.map(curriculum => {
                            return (
                                <Checkbox
                                    key={curriculum.id}
                                    checked={Array.isArray(curricula) && curricula.includes(curriculum.code)}
                                    toggle={() => {
                                        if (Array.isArray(curricula)) {
                                            const curricula_new = JSON.parse(JSON.stringify(curricula));
                                            if (curricula_new.includes(curriculum.code)) {
                                                curricula_new.splice(curricula_new.indexOf(curriculum.code), 1);
                                            } else {
                                                curricula_new.push(curriculum.code);
                                            }
                                            if (curricula_new.length > 0) {
                                                setCurricula(curricula_new);
                                            } else {
                                                setCurricula(null);
                                            }
                                        } else {
                                            setCurricula([curriculum.code]);
                                        }
                                    }}
                                    label={curriculum.name}/>
                            );
                        })}
                    </div>
                </div>
                <hr/>
                <h3>Links</h3>
                <div>
                    <button onClick={() => {
                        if (Array.isArray(links)) {
                            const links_new = JSON.parse(JSON.stringify(links));
                            links_new.push(getEmptyLink());
                            setLinks(links_new);
                        } else {
                            setLinks([getEmptyLink()]);
                        }
                    }}>+
                    </button>
                    <div className='d-flex flex-gap-10 flex-wrap'>{renderLinks()}</div>
                </div>
            </div>

            <div className='section d-flex flex-gap-10'>
                <button
                    type="submit"
                    className="button"
                    disabled={!challenge_code || !title}
                    onClick={event => {
                        event.preventDefault();
                        MindsetsJsSDK().API
                            .put('challenge_resources/' + params.challenge_resource_id, {
                                challenge_code,
                                title,
                                name,
                                url,
                                description,
                                quiz,
                                links,
                                curricula
                            })
                            .then(() => {
                                dispatch(SuccessMessageAction('New Resource has been updated.'));
                                navigate(-1);
                            })
                            .catch(error => {
                                dispatch(ErrorMessageAction(error));
                                console.error(error);
                            });
                    }}>Submit
                </button>
                <button className="button default" onClick={event => {
                    event.preventDefault();
                    navigate(-1);
                }}>Cancel
                </button>
            </div>
        </div>
    );
}
